'use strict';

(function ($) {

	/**
  * NavigationSearch
  *
  * @author Matthias Giger <matthias.giger@namics.com>
  */
	T.Module.NavigationSearch = T.createModule({

		_selectors: {
			overlay: '[data-js-m-navigation-search__overlay]',
			button: '[data-js-a-navigation-button]',
			icon: '[data-js-m-navigation-search__icon]',
			input: '[data-js-m-navigation-search__input]',
			banner: '.m-banner'
		},

		_eventNames: {
			toggle: 'navigation-search-toggle',
			close: 'navigation-button-close',
			query: 'm-search-query'
		},

		_stateClasses: {
			open: 'state-open',
			closed: 'state-closed',
			bannerOpen: 'm-banner--open'
		},

		start: function start(resolve) {
			var _this = this;

			this.$ctx = $(this._ctx);

			this.$buttons = this.$ctx.parent().find(this._selectors.button);

			this._events.on(this._eventNames.toggle, this.toggle.bind(this));
			this._events.on(this._eventNames.query, this.setQuery.bind(this));

			this.$icon = this.$ctx.find(this._selectors.icon);
			this.$input = this.$ctx.find(this._selectors.input);
			this.$banner = $(this._selectors.banner);

			this.$icon.click(this.submit.bind(this));

			// Empty input on escape key or Close if already empty
			$(document).keyup(function (event) {
				if (event.keyCode === 27 && _this.$ctx.hasClass(_this._stateClasses.open)) {
					_this.clearOrCloseInput();
				}
			});

			// Go to search result page on enter
			$(document).keyup(function (event) {
				var code = event.keyCode || event.which;

				if (code === 13 && _this.$ctx.hasClass(_this._stateClasses.open)) {
					_this.submit();
				}
			});

			// Close When The user Clicks Outside of the component and the buttons
			$(document).mouseup(function (event) {
				if (_this.$ctx.hasClass(_this._stateClasses.open) && _this.isClickOutSideOf(_this.$ctx, event.target) && _this.isClickOutSideOf(_this.$buttons, event.target)) {
					_this._events.emit(_this._eventNames.close, 'anonymous');
				}
			});

			resolve();
		},
		toggle: function toggle() {
			if (this.$ctx.hasClass(this._stateClasses.open)) {
				this.$ctx.addClass(this._stateClasses.closed);
				this.$ctx.removeClass(this._stateClasses.open);

				if (this.$banner.length && this.$banner.hasClass(this._stateClasses.bannerOpen)) {
					this.$ctx.css('top', '');
				}
			} else {
				this.$ctx.removeClass(this._stateClasses.closed);
				this.$ctx.addClass(this._stateClasses.open);
				this.focusInput();

				if (this.$banner.length && this.$banner.hasClass(this._stateClasses.bannerOpen)) {
					if (window.innerWidth < 501) {
						this.$ctx.css('top', 'calc(17.3vw + ' + this.$banner.outerHeight() + 'px)');
					} else {
						this.$ctx.css('top', this.$banner.outerHeight());
					}
				} else {
					this.$ctx.css('top', '');
				}
			}
		},
		setQuery: function setQuery(query) {
			if (query && query !== '') {
				this.toggle();
				this.$input.val(query);
			}
		},
		isClickOutSideOf: function isClickOutSideOf(element, target) {
			return !element.is(target) && element.has(target).length === 0;
		},
		submit: function submit() {
			var value = this.getInputValue();
			if (value || value !== '') {
				var url = this.$ctx.data('url');
				window.location.href = url + '?query=' + this.getInputValue();
			}
		},
		focusInput: function focusInput() {
			this.$input.focus();
		},
		clearOrCloseInput: function clearOrCloseInput() {
			var value = this.getInputValue();

			if (!value || value === '') {
				this._events.emit(this._eventNames.close, 'anonymous');
			} else {
				this.setInputValue('');
				this.focusInput();
			}
		},
		getInputValue: function getInputValue() {
			return this.$input.val();
		},
		setInputValue: function setInputValue(value) {
			return this.$input.val(value);
		}
	});
})(jQuery);